import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const apiCall = async (controller, apiName, method = "GET", body = null, token = null) => {
  const url = `/${controller}/${apiName}`;

  const config = {
    method,
    url,
    headers: {},
    data: body || undefined,
  };

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  try {
    const response = await apiClient(config);
    return response.data;
  } catch (error) {
    console.error("API call failed:", error);

    if (error.response) {
      const data = error.response.data;
      let message;

      if (data?.errors && typeof data.errors === "object") {
        message = Object.values(data.errors).flat().filter(Boolean).join("\n");
      }
      if (!message) {
        message =
          data?.message ||
          data?.title ||
          (typeof data === "string" ? data : null) ||
          `Request failed with status ${error.response.status}`;
      }

      const err = new Error(message);
      err.status = error.response.status;
      err.data = data;
      throw err;
    } else if (error.request) {
      throw new Error("No response from server. Please check your connection.");
    } else {
      throw new Error(error.message || "Unexpected error occurred.");
    }
  }
};



// ProjectDetails page
export const checkSitaCodeUnique = (sitaCode, hotelId = null) => {
  const query = hotelId
    ? `?sitaCode=${sitaCode}&hotelId=${hotelId}`
    : `?sitaCode=${sitaCode}`;
  return apiCall("NetZero", `CheckSitaCodeUnique${query}`);
};

export const getHotelByUserId = (userId) => {
  return apiCall("NetZero", `GetHotelByUserId/${userId}`);
};

export const getHotelFullDetails = (hotelId) => {
  return apiCall("NetZero", `GetHotelFullDetails/${hotelId}`);
};

export const addHotelReadinessDetails = (data, token) => {
  return apiCall("NetZero", "AddHotelReadinessDetails", "POST", data, token);
};

// Login page
export const loginUser = (data) => {
  return apiCall("auth", "Login", "POST", data);
};

export const googleSignIn = (idToken, role = "User") => {
  return apiCall("auth", "GoogleSignIn", "POST", { idToken, role });
};

export const registerUser = (data) => {
  return apiCall("auth", "Register", "POST", data);
};

// Dashboard page
export const getAllHotelDetails = () => {
  return apiCall("NetZero", "GetAllHotelDetails");
};

export const deleteHotels = (hotelIds, token) => {
  return apiCall("NetZero", "DeleteHotels", "DELETE", hotelIds, token);
};

export const downloadHotelsExcel = (hotelIds = []) => {
  const query = hotelIds.length
    ? `?${hotelIds.map((id) => `hotelIds=${id}`).join("&")}`
    : "";
  return `${BASE_URL}/NetZero/DownloadHotelsExcel${query}`;
};